var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXtb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 170.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGOS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RGB"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "253.5 125.59 241.2 104 229.18 125.59 199.53 125.59 226.99 84.75 200.62 47.22 230.68 47.22 241.34 66.06 252.27 47.22 282.05 47.22 255.68 84.75 283.28 125.59 253.5 125.59 253.5 125.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.21,127.79c-10,0-17.36-4-23.09-12.51v10.45H366.71V23.2H392V57.12c5.19-8,13.25-12.23,23.5-12.23,18.44,0,32.52,16.49,32.52,41.93,0,24.75-13.66,41-32.79,41M407,65c-9.56,0-15.3,7.42-15.3,20.62,0,14.3,5.19,21.72,14.75,21.72s15.17-7.56,15.17-21.72C421.63,72.66,415.89,65,407,65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.09,66.53V47.22H333v-24H307.56v24H297.17V66.53h10.39V101c0,5.91-3.53,34.34,38.25,24.75V109.37a30,30,0,0,1-3.28.13c-8.06,0-9.56-3.44-9.56-12.78V66.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.32,171H165.58a4.31,4.31,0,0,0,4.32-4.32V4.32A4.31,4.31,0,0,0,165.58,0H4.32A4.31,4.31,0,0,0,0,4.32V166.65A4.31,4.31,0,0,0,4.32,171Zm111.14-49.76c-.71-.67-1.43-1.34-2.15-2A208,208,0,0,0,88.14,99.67a256.68,256.68,0,0,1-25.43,13.58l-53-10.62a246.51,246.51,0,0,0,30.48-10q10-4,19.43-8.9-6-2.81-12.1-5.29a247.49,247.49,0,0,0-30.47-10L70,57.73q9,4.17,17.49,8.93A203,203,0,0,0,106,51.75c.73-.65,1.44-1.31,2.16-2l44.71-8.49A217.46,217.46,0,0,1,112.56,82.7a219.68,219.68,0,0,1,47.61,47l-44.71-8.49Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtb);
export default __webpack_public_path__ + "static/media/xtb.e43827c8fa015086351599877053e2d5.svg";
export { ForwardRef as ReactComponent };